import { render, staticRenderFns } from "./divisionbyclass.vue?vue&type=template&id=950e2a26&"
import script from "./divisionbyclass.vue?vue&type=script&lang=js&"
export * from "./divisionbyclass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports